// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-form-drawer .el-drawer__body{padding:0 20px}", ""]);
// Exports
module.exports = exports;
